export default class NetworkLinkDto {
    constructor(obj) {
        this.idStation = obj.idStation || obj.idQualito || obj.idPiezometer
        this.idNetwork = obj.idNetwork
        this.startDate = obj.startDate
        this.endDate = obj.endDate
    }
}